import PharmaDrugsText from './PharmaDrugsText';
import DrugButtonGroup from '../ButtonGroup/DrugButtonGroup';
import DrugAccCard from '../Sections/DrugAccCard';
import SectionStructure from '../../../../../components/Section/SectionStructure';


export default function SectionPharmaDrugs() {

return (

<SectionStructure
    
    sectiontext=    { <PharmaDrugsText />  }
    sectiondiagroup=    { <DrugButtonGroup />} 

     sectioncards=  { <DrugAccCard />  }

    />          
    )
}